var widget = {
  name: "cnHeader",
  title: "Floating Headers",
  iconName: "",
  widgetIsLoaded: function () {
      return true; 
  },
  isFit: function (question) {
    return question.renderAs === 'cn_header';
  },
  afterRender: function (question, el) {
      el.id = question.name;

      // setTimeout( () => {
      //   var tb = document.getElementById(`cn_header_${question.name}`);
      //   if( tb ){
      //     var clone = tb.cloneNode(true);
         
      //     clone.id = `cn_header_${question.name}_clone`
      //     clone.classList.add("white--background");
      //     clone.classList.add("elevation-2");
      //     clone.classList.add("pt-2");
      //     clone.classList.add("pb-1");
      //     clone.classList.remove("active");
      //     var rate = clone.getElementsByClassName('remove_clone');
      //     for (var i = rate.length - 1; i >= 0; i--) {
      //       rate[i].classList.add("hidden");
      //     }          
      //     el.append( clone )
      //   }
        // else{       
          el.classList.add("cn-header");
          el.classList.add("elevation-2");
          el.classList.add("pa-3");
          el.innerText = question.title; 
        // }
      // }, 1000 )
  },

}

export default widget;

